module.exports = __webpack_public_path__ + "files/SPIADI2025 - TOP CVP - Guide Technique (Version 2).3f65dd217f0fef87d6c374c010ab6adc.pdf";